import { Injectable } from '@angular/core';
import { OnInit } from '@angular/core';
declare let THREE: any;
import { ComponentBase } from '../../component-base';
import { StageService } from '../../services/stage.service';
import { ObjectCheckerService } from '../../services/object-checker.service';
import { UndoService } from '../../services/undo.service';
import { SceneUtilsService } from '../../services/scene-utils.service';
import { KeyStateService } from '../../services/key-state.service';
import { Model3DService } from '../../services/model3-d.service';
import { ConstantsService } from '../../services/constants.service';




@Injectable()
export class Selection2DService extends ComponentBase implements OnInit {

  constructor(private stage: StageService,
    private objectCheckerSrvc: ObjectCheckerService,
    private undoSrvc: UndoService,
    private sceneUtils: SceneUtilsService,
    private keyState: KeyStateService,
    private model3D: Model3DService,
    private constants: ConstantsService) {
    super();
  }

  highlightObject(mesh, val) {
    if (!mesh)
      return;
    var border = mesh.getObjectByName('2D')
      .getObjectByName('border');
    if (border) {
      if (!val)
        border.visible = false;
      else {
        border.material.color.setHex(this.constants.HighlightState.SELECTED);
        border.visible = true;
      }
    }
  }

  private activeEntity: any;
  selectedObject: any;
  mouseDownTime: any;

  keyDown(e) {
    if (e.keyCode === 46 && this.selectedObject) {
      var obj = this.selectedObject;
      if (!this.objectCheckerSrvc.isWall(obj) && !this.objectCheckerSrvc.isFloor(obj)) {
        this.stage.remove(obj);
        this.undoSrvc.push('delete', obj);
        this.setSelected(null);
      }
    }
  }

  setSelected(obj) {

    //unhighlight old object
    if (this.selectedObject !== obj)
      this.highlightObject(this.selectedObject, false);

    this.highlightObject(obj, true);

    this.selectedObject = obj;
    this.fireEvent('objectSelect', obj);

    //this._Scene2d.render();
  }

  pickObject(e) {

    var raycaster = this.sceneUtils.getRay(e.offsetX, e.offsetY);
    raycaster.ray.origin.y = 1000;

    var result = null;

    var objects = this.stage.getChildren().filter(function (obj) {
      return obj.visible &&
        !this.objectCheckerSrvc.isWall(obj) &&
        obj.userData.entity;
    }.bind(this)).map(function (obj) {
      return obj.getObjectByName('2D');
    });

    var intersected = raycaster.intersectObjects(objects);

    if (intersected.length !== 0) {
      result = intersected.sort(function (a, b) {
        return b.object.renderOrder - a.object.renderOrder;
      })[0];
    }

    return result;
  }

  mouseDown(e) {

    this.mouseDownTime = new Date().getTime();

    var intersected = this.pickObject(e);

    if (this.selectedObject || !intersected)
      this.setSelected(null);

    if (intersected)
      this.setSelected(intersected.object.parent);
  }

  mouseUp(e) {
    var intersected = this.pickObject(e);
    if (intersected) {
      this.fireEvent('select2D', intersected.object);
    }
  }

  mouseEnter() {
    if (this.activeEntity && this.keyState.result.isMouseHold) {
      //var obj = this._roomStuffFactory.buildRoomItem(this._activeEntity);
      //obj.visible = false;
      //this.stage.add(obj);

      if (this.activeEntity.isGeneric) {
        var casing = 8.255;
      } else {
        var casing = 0;
      }


      var obj = this.model3D.create(this.activeEntity, {
        casing: casing
      }
      );
      this.stage.add(obj);

      this.setSelected(obj);
    }
  }

  mouseLeave() {
    if (this.keyState.result.isMouseHold && this.selectedObject) {
      this.stage.remove(this.selectedObject);
      this.activeEntity = null;
      this.setSelected(null);
      //  this._Scene2d.render();
    }
  }

  setActiveEntity(entity) {
    this.activeEntity = entity;
  }

  disable() {
    ComponentBase.prototype.disable.call(this);
    this.setSelected(null);
  }

  ngOnInit() {
    ComponentBase.call(this);

    this.activeEntity = null;
    this.selectedObject = null;
  }

}



// WEBPACK FOOTER //
// ./src/app/Component(2D and 3D)/2D/selection2-d.service.ts